import script from "./SearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=09ed2346&lang=less&scoped=true"

import exportComponent from "D:\\Change\\MyGit\\Close\\public\\02_don't_need_to_update\\Navigation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ed2346"]])

export default __exports__